export default __webpack_public_path__ + "static/bumpa-addproduct-new-e83c103fc976a0a2137a9994ba052aa0.mp4";